// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import AnalyticsFilters from '../../components/Analytics/AnalyticsFilters'
import AnalyticsGoogleChartGraphics from '../../components/Analytics/AnalyticsGoogleChartGraphics';
import ReactGA from "react-ga4";

var analyticsCommonJS = require("../../js/analyticsCommon.js");
var initialConfigCommonJS = require("../../js/initialConfigCommon.js")

var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var fechaActual = (new Date(Date.now() - tzoffset)).toISOString()

// HELIAS ANALYTICS
const HeliasAnalytics = (params) => {

  useEffect(() => {      

    document.getElementById("botonFavoritoAnalytics").className = document.getElementById("botonFavoritoAnalytics").className.replaceAll(" selected", "")
    
    if(localStorage.getItem("analyticsQueryRequest") === null){
      analyticsCommonJS.cargaInicialHistorico()
      analyticsCommonJS.actualizarGrafica("default", setObjQueryGrafica, ReactGA)                
    }
    else{ //Muestro la petición
      analyticsCommonJS.actualizarGrafica("analyticsQueryRequest",setObjQueryGrafica, ReactGA)
    }

    console.log("Gráfica analítica default cargada correctamente.")    

  }, [params.update]);

  const [objQueryGrafica, setObjQueryGrafica] = useState({"fromDatetime": fechaActual.substring(0,19),"toDatetime": fechaActual.substring(0,19),"queryFilters":""})

  function seleccionarPestañaAnalytics(pestaña){

    if( (pestaña !== "Personalizado") && (pestaña !== "Favorita") ){
      document.getElementById("pestañaAnalytics"+pestaña).checked = true
    }

    var fechaActual = new Date();    

    var añoActual = fechaActual.getFullYear();
    var mesActual = (fechaActual.getMonth()+1);
    var diaActual = fechaActual.getDate();

    var diaDesde = ""
    var mesDesde = ""
    var añoDesde = ""

    var fechaDesdeFormateada = ""
    var fechaHastaFormateada = ""
    var horaDesdeFormateada = "";      
    var horaHastaFormateada = "";

    if(pestaña === "Dia"){      
      
      if (mesActual < 10){ mesActual = "0"+mesActual;	}
      if (diaActual < 10){ diaActual = "0"+diaActual;	}
      
      fechaHastaFormateada = añoActual+"-"+mesActual+"-"+diaActual;
      fechaDesdeFormateada = añoActual+"-"+mesActual+"-"+diaActual; //Por ahora seteo datos al día actual, ya meteré rangos
      horaDesdeFormateada = "00:00";
      horaHastaFormateada = "23:59";
  
      document.getElementById("fechaDesde").value = fechaDesdeFormateada;
      document.getElementById("fechaHasta").value = fechaHastaFormateada;
      document.getElementById("horaDesde").value = horaDesdeFormateada;
      document.getElementById("horaHasta").value = horaHastaFormateada;

    }
    else if(pestaña === "Semana"){
      
      //Calculo fechaHasta (que sería el día de hoy)

      if (mesActual < 10){ mesActual = "0"+mesActual;	}
      if (diaActual < 10){ diaActual = "0"+diaActual;	}

      fechaHastaFormateada = añoActual+"-"+mesActual+"-"+diaActual;      
      horaHastaFormateada = "23:59"

      var diasDesdeElLunes = fechaActual.getDay()-1

      if(diasDesdeElLunes < 0){
        diasDesdeElLunes = 6
      }

      fechaDesdeFormateada = analyticsCommonJS.calcularNuevaFecha("restar",diaActual,mesActual,añoActual, diasDesdeElLunes) 
      horaDesdeFormateada = "00:00"
      
    }
    else if(pestaña === "Mes"){
      
      diaDesde = 1
      mesDesde = mesActual
      añoDesde = añoActual

      if (mesDesde < 10){ mesDesde = "0"+mesDesde;	}
      if (diaDesde < 10){ diaDesde = "0"+diaDesde;	}

      fechaDesdeFormateada = añoDesde+"-"+mesDesde+"-"+diaDesde; 
      
      //Calculo fechaHasta (que sería el día de hoy)

      if (mesActual < 10){ mesActual = "0"+mesActual;	}
      if (diaActual < 10){ diaActual = "0"+diaActual;	}

      fechaHastaFormateada = añoActual+"-"+mesActual+"-"+diaActual;      
      
      horaDesdeFormateada = "00:00"
      horaHastaFormateada = "23:59"

    }
    else if(pestaña === "Personalizado"){ //Personalizado      
      analyticsCommonJS.abrirMenuFiltrado("Fechas")
    }  
    else { //Búsqueda favorita

      if(localStorage.getItem("fq"+localStorage.getItem("installationId")) !== null){

        if(!document.getElementById("botonFavoritoAnalytics").className.includes(" selected")){
          var CryptoJS = require("crypto-js");      
          var datos = CryptoJS.AES.decrypt(localStorage.getItem("fq"+localStorage.getItem("installationId")), localStorage.getItem("installationId").substring(0,16)).toString(CryptoJS.enc.Utf8);        
          analyticsCommonJS.setearFiltradoActual(datos)

          fechaDesdeFormateada = document.getElementById("fechaDesde").value
          fechaHastaFormateada = document.getElementById("fechaHasta").value
          horaDesdeFormateada = document.getElementById("horaDesde").value
          horaHastaFormateada = document.getElementById("horaHasta").value

          document.getElementById("botonFavoritoAnalytics").className = document.getElementById("botonFavoritoAnalytics").className.replaceAll(" selected", "") + " selected"

          analyticsCommonJS.actualizarGrafica("filtros", setObjQueryGrafica, ReactGA)
        }

      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("No tienes datos favoritos en este dispositivo. Realiza un filtrado y márcalo como favorito para repetirlo pulsando aquí.","info")              
        pestaña = "Personalizado" //Aprovecho esta variable para no lanzar la búsqueda en este caso
      }

    }  

    if( (pestaña !== "Personalizado") && (pestaña !== "Favorita") ){

      document.getElementById("fechaDesde").value = fechaDesdeFormateada;
      document.getElementById("fechaHasta").value = fechaHastaFormateada;
      document.getElementById("horaDesde").value = horaDesdeFormateada;
      document.getElementById("horaHasta").value = horaHastaFormateada;

      analyticsCommonJS.actualizarGrafica("filtros", setObjQueryGrafica, ReactGA)

    }

  }
    
  return ( 
    
    <div className="modal-content full-width"> 
      <button className="link close" onClick={() => params.operarDetalleLateralPantallaCompleta("cerrar")}><span className="material-icon">highlight_off</span></button>
      <div className="page wrapper fill">      

        <section id="analytics" className="vertical gap-04 fill" >

          <div id="botoneraPrincipal" className="content-wrapper" > 

            <div className="horizontal space-between">
              <h1 className="headline-02">Histórico</h1>              
              
              <div className="horizontal gap-02">
                <button id="botonFavoritoAnalytics" className="button tertiary size-s" onClick={ () => seleccionarPestañaAnalytics("Favorita")}><span className="material-icon">grade</span></button>
                <button className="button tertiary size-s" onClick={ () => analyticsCommonJS.abrirMenuFiltrado("Datos")}><span className="material-icon">edit_note</span>Datos</button>
              </div>
            </div>

            <div className="dateview">

              <div className="tabs timeview">

                <input type="radio" id="pestañaAnalyticsDia" name="timeview" defaultChecked />
                <label htmlFor="day" className="text-center gap-02" onClick={ () => seleccionarPestañaAnalytics("Dia")}>
                  <span className="material-icon">today</span>
                  <span className="label">Día</span>
                </label>

                <input type="radio" id="pestañaAnalyticsSemana" name="timeview" />
                <label htmlFor="week" className="text-center gap-02" onClick={ () => seleccionarPestañaAnalytics("Semana")}>
                  <span className="material-icon">date_range</span>
                  <span className="label">Semana</span>
                </label>

                <input type="radio" id="pestañaAnalyticsMes" name="timeview" />
                <label htmlFor="month" className="text-center gap-02" onClick={ () => seleccionarPestañaAnalytics("Mes")}>
                  <span className="material-icon">calendar_month</span>
                  <span className="label">Mes</span> 
                </label>

                <input type="radio" id="pestañaAnalyticsPersonalizado" name="timeview" />
                <label htmlFor="period" className="text-center gap-02" onClick={ () => seleccionarPestañaAnalytics("Personalizado")}>
                  <span className="material-icon hiddens">edit_calendar</span>
                  <span className="label">Personalizado</span>
                </label>

              </div>

              <div className="date-navigation">
                
                <button id="botonDiaAnterior" className="button tertiary rounded size-s" onClick={() => analyticsCommonJS.navegarDatosDia("anterior",setObjQueryGrafica, ReactGA)}>
                  <span className="material-icon">navigate_before</span>
                </button>

                <span id="etiquetaFechaNoEditable" className="date-content text-center size-l"></span>

                <div id ="divEtiquetaFechaEditable"className="horizontal gap-02 center date-content hidden" onClick={() => analyticsCommonJS.abrirMenuFiltrado("Fechas")}>                
                  <span id="etiquetaFechaEditable" className="label text-center size-l" style={{paddingTop: "1px"}}></span>
                  <span className="material-icon link size-s">edit_calendar</span>
                </div>

                <button id="botonDiaSiguiente" className="button tertiary rounded size-s" onClick={() => analyticsCommonJS.navegarDatosDia("siguiente",setObjQueryGrafica, ReactGA)}> 
                  <span className="material-icon">navigate_next</span>
                </button>

              </div>

            </div>

          </div>        

          <div className='chart-wrapper'>
            <AnalyticsGoogleChartGraphics graphicId={"graficaAnalytics"} objQueryGrafica={objQueryGrafica} /> 
          </div>

        </section>

        <AnalyticsFilters actualizarGrafica={analyticsCommonJS.actualizarGrafica} setObjQueryGrafica={setObjQueryGrafica} objQueryGrafica={objQueryGrafica}/>

      </div>
    </div>
  )
}

export default HeliasAnalytics